import React from "react";
import { Navigate, Outlet } from "react-router-dom";

interface ProtectedRouteProps {
  allowedRoles: number[]; // Lista de tipos de usuário permitidos
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  // Verifica se o usuário está autenticado
  const isAuthenticated = !!user && allowedRoles.includes(user.type);

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;

